<template>
  <el-drawer
    title="Detalles GPS Navixy"
    :visible="DriwerVisible"
    size="70%"
    append-to-body
    @close="Onclose"
  >
    <el-row>
      <el-col>
        <br />
        <TableGpsStatus ref="gps" :clientCode="Client" />
      </el-col>
    </el-row>
  </el-drawer>
</template>

<script>
import TableGpsStatus from "./TableGpsStatus.vue";

export default {
  components: { TableGpsStatus },
  name: "GpsDrawerNavixy",
  props: {
    visible: {
      typeof: Boolean,
      default: false
    },
    Client: {
      typeof: String,
      default: ""
    }
  },
  data() {
    return {
      DriwerVisible: false
    };
  },

  methods: {
    Onclose() {
      this.DriwerVisible = false;
      this.$emit("CloseGPSNavixy", false);
    },
    GetItems(client) {
      this.$nextTick(() => {
        this.$refs.gps.getItems(client);
      });
    }
  },

  watch: {
    async visible(newValue) {
      if (newValue) {
        this.GetItems(this.Client);
        this.DriwerVisible = newValue;
      }
    }
  }
};
</script>
